import { render, staticRenderFns } from "./aboutIntroduce.vue?vue&type=template&id=a0e65376&"
import script from "./aboutIntroduce.vue?vue&type=script&lang=js&"
export * from "./aboutIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./aboutIntroduce.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports